/*
 * @Author: your name
 * @Date: 2020-10-22 14:02:44
 * @LastEditTime: 2021-11-24 22:51:23
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ksh-factory-vue/src/utils/request.js
 */
import axios from 'axios'
import { getToken } from '@/utils/auth'
import {createRequestSign} from './util'

// import BASE_CONFIG from 'BASE_CONFIG'

// 创建axios实例
const service = axios.create({
    // baseURL: BASE_CONFIG.BASE_URL, // api 的 base_url
    baseURL: '/', // api 的 base_url
    timeout: 30000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
    config => {
        config['Content-Type'] = 'application/json'
        // config.headers['token'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
        config.headers['Cache-Control'] = 'no-cache'
        let t = new Date().getTime()
        config.headers['timestamp'] = t
        config.headers['sign'] = createRequestSign(config.url,t)
        config.headers['appKey'] = 1001
        return config
    },
    error => {
    // Do something with request error
        Promise.reject(error)
    }
)

// response 拦截器
service.interceptors.response.use(
    response => {
        const res = response.data
        const { code, message } = res
        if (code === 0) {
            return res
        } else {    // todo 异常处理逻辑
            return Promise.reject({
                code: code,
                message: message
            })
        }
    },
    error => {
        console.log('err:', error) // for debug
        if (!error.response.status) return
        // 返回的err只是字符串 没有返回的必要 反而影响rea.message 所以直接reject 没有返回error
        return Promise.reject()
    }
)

export default service
